import { Controller, useFormContext } from 'react-hook-form';

import FuelTags from '../fuel-tags';

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  defaultValue?: string | number;
  ouIds?: string[];
  inputTagWidth?: number;
  /** When true, show a clear button that wipes all tags at once. Per-chip delete still works. */
  allowClear?: boolean;
};

const VNTags = ({
  name,
  label = '',
  disabled = false,
  defaultValue,
  ouIds,
  inputTagWidth = 300,
  allowClear = false,
}: Props) => {
  const { control } = useFormContext();

  return (
    <div className="vn-tags-container">
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { value, onChange } }) => {
          return (
            <FuelTags
              id={name}
              inputTagWidth={inputTagWidth}
              tags={value ?? []}
              onChange={(tags) => onChange(tags)}
              labelText={label}
              disabled={disabled}
              ouIds={ouIds}
              allowClear={allowClear}
            />
          );
        }}
      />
    </div>
  );
};

export default VNTags;
